import React from 'react';
import {t} from '@lingui/core/macro';

import {NewPassword} from 'features/auth';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';

const NewPasswordPage: React.FC = () => {
    return (
        <BlankLayout pageTitle={t`Новый пароль`}>
            <NewPassword/>
        </BlankLayout>
    );
};

export default NewPasswordPage;